import usercategories from "../../data/usersCategories.json";

export const EmployerPage = () => {
  return (
    <section className="w-full max-w-[1312px] bg-gradient-to-r from-[#ECF1FF] to-[#EED8FF] rounded-b-2xl px-4">
      <div className='  my-5 '>
        <div className='text-[#454545]'>
          <h2 className="text-2xl sm:text-3xl lg:text-[36px] font-bold text-center">
            For Employers
          </h2>
          <h4 className="text-lg sm:text-xl lg:text-[18px] font-semibold text-center">
            Smarter Hiring, Faster Results
          </h4>
        </div>
        {/* Cards */}
        <div className="flex justify-center gap-6 mt-10 flex-wrap">
          {usercategories?.HowEmployers &&
            usercategories?.HowEmployers.map((user, index) => (
              <div
                key={index}
                className="bg-white rounded-[12px] w-full sm:w-[220px] md:w-[250px] px-6 py-5 h-[330px] space-y-2 shadow-sm flex flex-col"
              >
                <div className='flex justify-center'>
                  <div className={`bg-gradient-to-r  ${index % 2 === 0 ? "from-[#FF512F] to-[#F09819]" : "from-[#56AB2F] to-[#A8E063]"} rounded-xl p-2 w-10 h-10 flex justify-center items-center`}>
                    <img
                      src={user?.icon}
                      alt={user.heading}
                      className="w-6 h-6 sm:w-auto sm:h-auto"
                    />
                  </div>
                </div>
                <h3 className="font-semibold text-base sm:text-lg text-center">
                  {user.Heading}
                </h3>
                <p className="text-sm text-gray-600 text-center md:text-left">
                  {user?.subHeading}
                </p>
                <ul className="list-disc pl-5 space-y-1 text-[14px] text-gray-600">
                  {user.Listing.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
        </div>
        {/* <div className="flex justify-center mt-10">
          <Button
            className="w-[200px] h-[48px] bg-white border border-[#2C25C4] text-[#2C25C4] rounded-[8px]"
            children={`Browse Jobs Now`}
          />
        </div> */}
      </div>
    </section>
  )
}
